/* eslint-disable no-useless-escape */
import { useState } from 'react';
import PropTypes from 'prop-types';
import Table from '../common/table/Table';
import { Row, Col } from 'react-bootstrap';
import LinearChart from './LinearChart';
import './DetectionOverview.scss';
import { useTranslation } from 'react-i18next';

const DetectionOverview = (props) => {
    const { t, ready } = useTranslation();
    const [tableContent, setTableContent] = useState(null);

    if (props.data.length > 0 && tableContent !== props.data){
        setTableContent(props.data);
    }

    if (!ready) {
        return null;
    }

    return (
        <div className='detectionOverview'>
            <Table
                columns={props.columns}
                data={props.data}
                useSorting={false}>
            </Table>

            <Row>
                <Col md={3} >
                    <p className='detectionText'>
                        {t('The most searched for threats on MetaDefender Cloud based on user requests')}
                    </p>
                    <p className='detectionText' dangerouslySetInnerHTML={{ __html: t('* Commercial Cloud with 20+ engines. For a complete list see our<a href=\"/licensing\" rel=\"noopener noreferrer\" target=\"_blank\"> licensing </a>page') }}>
                    </p>
                </Col>

                <Col lg={9} md={12}>
                    <LinearChart labels={props.labels} points={props.points} engines={props.engines}/>
                </Col>
            </Row>

            <Row>
                <Col>
                    <p className='mobileText'>
                        {t('The most searched for threats on MetaDefender Cloud based on user requests')}
                    </p>
                    <br />
                    <p className='mobileText' dangerouslySetInnerHTML={{ __html: t('* Commercial Cloud with 20+ engines. For a complete list see our<a href=\"/licensing\" rel=\"noopener noreferrer\" target=\"_blank\"> licensing </a>page') }}/>
                </Col>
            </Row>
        </div>
    );
};

DetectionOverview.propTypes = {
    columns: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    labels: PropTypes.array,
    points: PropTypes.array,
    engines: PropTypes.array
};

export default DetectionOverview;
